import { Common } from '@stockbit/ui';
import Image from 'global/Image';
import { useMemo, useState } from 'react';
import Content from './Content';
import { IconArrow, ModalIndicatorBar, NotationBadgeContainer, NotationBar, NotationTag } from './styled';

const { Flex, Text } = Common;

interface IndicatorBarProps {
  symbol: string;
  uma: boolean;
  notation: Array<any>;
  name: string;
  type?: string;
  isGuestCompanyStock?: boolean;
  onClick?: (...args) => void;
}

const INDICATOR_ICON_URL = '/icon/ic_indicator.svg';

function IndicatorBar({ symbol, uma, notation, name, type = 'indicator', isGuestCompanyStock = false, onClick }: IndicatorBarProps) {
  const [isVisible, setVisible] = useState<boolean>(false);

  const onCloseModal = () => setVisible(false);

  const onOpenModal = () => setVisible(true);

  const onClickBar = (event) => {
    isGuestCompanyStock ? onClick(event) : onOpenModal();
  };

  const renderTag = (isNotationBadges) => (
    <NotationTag type={type} isSmall isNotationBadges={isNotationBadges}>
      <Image
        alt="indikator notasi khusus"
        src={INDICATOR_ICON_URL}
      />
    </NotationTag>
    );

  const notationList = useMemo(() => notation.map((item) => item?.notation_code), [notation]);

  return (
    <>
      <NotationBar align="center" justify="space-between" px="18px" onClick={onClickBar}>
        <Flex align="center" justify="flex-start">
          { renderTag(true) }
          <Text as="span" weight="600" size="11px" height="13.4px" ml="8px" family="bold" mr="6px">
            Perusahaan memiliki Notasi Khusus
          </Text>
          <NotationBadgeContainer>
            {notationList.map((code, index) => (
              <>
                {code}
                {index < notationList.length - 1 && (
                  <Image src="/icon/notsus-badge-dot.svg" />
                )}
              </>
            ))}
          </NotationBadgeContainer>
        </Flex>
        <Flex
          align="center"
          justify="flex-end"
          style={{ cursor: 'pointer' }}
        >
          <IconArrow as="span" />
        </Flex>
      </NotationBar>
      <ModalIndicatorBar
        visible={isVisible}
        onCancel={onCloseModal}
        title={null}
        centered
        width="520px"
        bodyStyle={{ padding: '16px' }}
      >
        <Content
          symbol={symbol}
          uma={uma}
          notation={notation}
          name={name}
          notationTag={renderTag(true)}
          isFullsize
        />
      </ModalIndicatorBar>
    </>
  );
}

export default IndicatorBar;
